<script setup lang="ts">
const { open } = useShoppingCartView();
</script>

<template>
	<button class="underline" @click="open">Wijzig je winkelwagen</button>
</template>
